import { createUrl } from "@/redux/api";
import {
  CreateBanRequest,
  DecideCaseRequest,
  ModerationCase,
  ModerationCaseQueryParams,
  SanctionQueryParams,
  Tags,
  TagsType,
  UserSanction,
} from "@/redux/moderation/types";
import { BuilderType, PaginatedResponse } from "@/redux/types";

const moderationService = (builder: BuilderType<Tags>) => ({
  getModerationCases: builder.query<
    ModerationCase[] | PaginatedResponse<ModerationCase>,
    ModerationCaseQueryParams
  >({
    query: (filters) => ({
      url: createUrl("/moderation/cases/", filters),
      method: "GET",
    }),
    providesTags: (): TagsType[] => [{ type: "ModerationCases" }],
  }),
  decideModerationCase: builder.mutation<ModerationCase, DecideCaseRequest>({
    query: ({ caseId, ...data }) => ({
      url: `/moderation/cases/${caseId}/decide/`,
      method: "POST",
      data,
    }),
    invalidatesTags: (_result, error): TagsType[] =>
      !error || ("status" in error && error.status === 409)
        ? [{ type: "ModerationCases" }]
        : [],
  }),
  getSanctions: builder.query<
    UserSanction[] | PaginatedResponse<UserSanction>,
    SanctionQueryParams
  >({
    query: (filters) => ({
      url: createUrl("/moderation/sanctions/", filters),
      method: "GET",
    }),
    providesTags: (): TagsType[] => [{ type: "Sanctions" }],
  }),
  banUser: builder.mutation<UserSanction, CreateBanRequest>({
    query: (data) => ({
      url: "/moderation/sanctions/",
      method: "POST",
      data: { ...data, kind: "BAN" },
    }),
    invalidatesTags: (_result, error): TagsType[] =>
      error ? [] : [{ type: "Sanctions" }],
  }),
  revokeSanction: builder.mutation<UserSanction, number>({
    query: (id) => ({
      url: `/moderation/sanctions/${id}/revoke/`,
      method: "POST",
    }),
    invalidatesTags: (_result, error): TagsType[] =>
      error ? [] : [{ type: "Sanctions" }],
  }),
});

export default moderationService;
